import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	graphPanelSplitterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	graphPanelSplitterLabel: {
		id: 'assets-graph-panel-splitter.graph-panel-splitter.graph-panel-splitter-label',
		defaultMessage: 'Assets Graph Panel Splitter',
		description:
			'Label for the Graph panel splitter component which allows a resizable content space',
	},
});
export default messages;
